import { useEffect } from "react";
import {useDispatch, useSelector} from "react-redux";

import { TimelineState } from "../store/timeline/types";
import { ApplicationState } from "../store";
import {setZoomRulerValues, setZoomTimelineScale} from "../store/timeline/actions";

const  { CONFIG } = window;


const useSetTimelineValues = () => {
    const { timelineScale } = useSelector<ApplicationState, TimelineState>(state => state.timeline);
    const dispatch = useDispatch();

    const zoomInHandler = () => {
        if (CONFIG.timelines[timelineScale - 1]) dispatch(setZoomTimelineScale(timelineScale - 1))
    };
    const zoomOutHandler = () => {
        if (CONFIG.timelines[timelineScale + 1]) dispatch(setZoomTimelineScale(timelineScale + 1))

    };

    useEffect(() => {
        const {duration, scaleMarkInterval, scaleTimeMarkInterval, title} = CONFIG.timelines[timelineScale];
        dispatch(setZoomRulerValues(duration * 1000, scaleMarkInterval * 1000, scaleTimeMarkInterval * 1000, title))
    }, [timelineScale]);


    return {zoomInHandler, zoomOutHandler}
};


export default useSetTimelineValues